<template>
  <v-toolbar
    v-if="backButtonHref != null"
    id="list-navigator--desktop"
    :bottom="!$vuetify.breakpoint.mdAndUp"
    :flat="$vuetify.breakpoint.mdAndUp"
    :width="$vuetify.breakpoint.mdAndUp ? 'initial': '100%'"
    v-bind:style="{
      zIndex: $vuetify.breakpoint.mdAndUp ? 'initial': '1',
    }"
  >
    <div
      class="d-flex flex-row align-center justify-space-between"
      :style="{ width: '100%' }"
    >
      <v-btn
        v-if="total > 0"
        :to="backButtonHref"
        dark
        icon
        class="back"
      >
        <v-icon
        :style="{color: '#27846d !important', fontSize: '34px'}"
        >
          icon-ayudadigital-volver
        </v-icon>
      </v-btn>

      <div
        v-if="total > 0"
        class="d-flex flex-row align-center justify-space-between pagination--buttons"
      >
        <v-btn
          dark
          icon
          color="primary"
          :disabled="current == 0"
          @click.stop="$emit('navigate', current - 1)"
        >
          <v-icon>
            {{ $vuetify.breakpoint.mdAndUp ? 'mdi-chevron-left' : 'mdi-arrow-left' }}
          </v-icon>
        </v-btn>

        <span class="mr-1" v-bind:style="{
          order: /*$vuetify.breakpoint.mdAndUp ? '-1' :*/ 'initial',
        }">
          {{ $t('commons.pageOf', [current + 1, total]) }}
        </span>
        <v-btn
          dark
          icon
          :disabled="current == total -1"
          @click.stop="$emit('navigate', current + 1)"
          color="primary"
        >
          <v-icon>
            {{ $vuetify.breakpoint.mdAndUp ? 'mdi-chevron-right' : 'mdi-arrow-right' }}
          </v-icon>
        </v-btn>
      </div>
    </div>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    backButtonHref: String,
    total: {
      type: Number,
      required: true,
    },
    current: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss">
  $list-navigator-top: 8px;
  $list-navigator-right: 40px;
  $list-navigator-right-xl: 70px;

  .v-sheet#list-navigator--desktop {
    background: transparent;
    box-shadow: none;
  }

  #list-navigator--desktop > .v-toolbar__content,
  #list-navigator--desktop .pagination--buttons {
    width: none;
  }

  @media screen and (min-width: 960px) {
    .v-application--is-ltr .v-toolbar__content
    > .v-btn.v-btn--icon:first-child, .v-application--is-ltr .v-toolbar__extension
    > .v-btn.v-btn--icon:first-child {
      margin-left: 0 !important;
    }

    /* #list-navigator--desktop {
      top: $list-navigator-top;
      right: $list-navigator-right;
    } */
    #list-navigator--desktop {
      top: initial;
      right: initial;

      .pagination--buttons {
        width: initial;
      }
    }
  }

  .back:hover {
    color: #27846d !important;
    caret-color: #27846d !important;
  }

  /* @media screen and (min-width: 1904px) {
    #list-navigator--desktop {
      top: $list-navigator-top;
      right: $list-navigator-right-xl;
    }
  } */
</style>
